exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".botao_senha[data-v-6fe6bfa2] {\n  cursor: pointer;\n  font-size: 18px;\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}", ""]);

// exports
